<div class="add-subfolder--container">
  <p>{{ data.title }}</p>

  <div class="add-input">
    <div class="subfolder-name">{{data.placeholder}}</div>
    <input
      style="width: 100% !important"
      id="subfoldernameInput"
      type="text"
      maxlength="40"
      (focus)="selectAllContent($event)"
      (input)="handleInput($event)"
      (keyup.enter)="confirmDialog()"
      [(ngModel)]="data?.currentFolderName ? data?.currentFolderName : subfolderName"
    />
  </div>

  <div class="action">
    <span (click)="closeDialog()">Cancel</span>
    <button mat-raised-button [disabled]="!subfolderName" [class.disable-button-continue]="checkIfDisabled()" (click)="confirmDialog()">
      {{ data.buttonName }}
    </button>
  </div>
</div>
